import { Icon, IconProps } from '@afterpaytouch/core'
import clsx from 'clsx'
import React, { FC } from 'react'
import styles from './style.module.css'

/**
 * @experimental
 * This is only used by the arcade new payment method experiment for now
 * will move to core after confirming the design
 */
export const RoundIcon: FC<IconProps> = ({ size = 'Medium', ...props }) => {
  const classes = clsx([styles.roundIconContainer, styles[size]])
  return (
    <div className={classes}>
      <Icon {...props} size={size} />
    </div>
  )
}
